/**
 * Registers the LessAlone service worker. Called once from main.tsx after
 * the page loads so the first paint is never blocked.
 *
 * The SW is required by the browser to expose "Add to Home Screen" on
 * Android Chrome and the standalone display mode on iOS Safari 16.4+.
 * The SW itself is a no-op fetch handler (see public/sw.js) — we don't
 * cache HTML or API responses because stale message data would degrade
 * the chat product.
 */
export function registerServiceWorker(): void {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;
  // Only register on HTTPS or localhost; an http: origin will refuse.
  const isSecure = window.isSecureContext || window.location.hostname === 'localhost';
  if (!isSecure) return;

  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch((err) => {
      // SW registration failures shouldn't break the app — log only.
      console.warn('[pwa] service worker registration failed', err);
    });
  });
}
